<template>
  <div class="homepage">
    <!-- <video-bg
      id="background-video"
      class="video-background"
      :sources="videoPath"
      img=""
    />-->

    <!-- topbar -->
    <app-topbar />

    <!-- Home Grid -->
    <section id="grid-container">
      <transition
        name="fade-in"
        appear
        appear-active-class="animated fadeInUp"
        v-for="(link, index) in homepageLinks"
        :key="index"
      >
        <router-link :to="link.to" tag="a" :class="neededClasses(link)">
          <v-icon class="no-select">{{ link.icon }}</v-icon>
          {{ $t(link.title) }}
        </router-link>
      </transition>
    </section>
    <!-- / Home Grid -->

    <add-dollar-price :addDialog="dialogs.addDialog" @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)" />

    <change-password-component
      :changePasswordDialog="dialogs.changePasswordDialog"
      @hidemodal="resetAllErrors(true), (dialogs.changePasswordDialog = false), callDollarPrice()"
    />

    <!-- Footer -->
    <app-footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppTopbarVue from '../_partials/AppTopbar.vue'
import AppFooterVue from '../_partials/AppFooter.vue'
import addDollarPrice from '../accounting/dollarRates/addDollarRate.vue'
import * as helpers from '@/mixins/helperFunctions.js'
import changePasswordComponent from '../auth/changePasswordComponent.vue'

export default {
  name: 'Login',

  components: {
    appTopbar: AppTopbarVue,
    appFooter: AppFooterVue,
    addDollarPrice,
    changePasswordComponent
  },

  data() {
    return {
      baseurl: `${window.location.protocol}//${window.location.hostname}`,
      dialogs: {
        addDialog: false,
        changePasswordDialog: false
      }
      // videoPath: ['http://pos-build.test/assets/vids/video-1.mp4']
      // videoPath: ['']
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Accounting & POS System'),
      icon: 'fa-chalkboard-teacher'
    })

    // this.controlBackgroundVideo()
    // this.togglePausingBackgroundVideo()
    if (this.authUserData.is_password_changed.toLowerCase() === 'no') {
      this.dialogs.changePasswordDialog = true
    } else {
      this.callDollarPrice()
    }
  },

  computed: {
    ...mapGetters({
      homepageLinks: 'home/homepageLinks',
      authUserData: 'auth/getAuthUserData'
    })
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors'
    }),

    callDollarPrice() {
      if (localStorage.lastShownDollarPrice) {
        let lastDate = new Date(Date.parse(localStorage.lastShownDollarPrice))
        lastDate.setHours(0, 0, 0, 0)
        const today = new Date().setHours(0, 0, 0, 0)

        if (lastDate < today) {
          this.showDollarPrice()
        }
      } else {
        this.showDollarPrice()
      }
    },

    showDollarPrice() {
      if (helpers.userHasPermissions(['dollar_prices_store'])) {
        this.dialogs.addDialog = true
        localStorage.lastShownDollarPrice = new Date()
      }
    },

    neededClasses(link) {
      let classes = link.row
      classes += link.id === 0 || helpers.userHasSidebarPermissions(link.id) ? '' : ' disableLink'
      classes += link.fa ? ' fa-icon' : ''
      classes += link.specialClass !== '' ? ` ${link.specialClass}` : ''
      return classes
    },

    controlBackgroundVideo() {
      document.querySelector('#background-video video').playbackRate = 0.8
    },

    togglePausingBackgroundVideo() {
      let bgVideo = document.querySelector('#background-video video')
      let videoContent = document.querySelector('.VideoBg__content')

      videoContent.addEventListener('click', () => {
        if (bgVideo.paused) {
          bgVideo.play()
        } else {
          bgVideo.pause()
        }
      })
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  position: fixed;
  top: 0;
  z-index: 9999;
}

.video-background {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  opacity: 0.4;
}

.layout {
  width: 100%;
  height: 100vh;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  background: yellow;
}

#grid-container {
  width: 1000px;
  height: auto;
  display: grid;
  gap: 10px;
  position: relative;
  top: 100px;
  margin: 0 auto !important;
  background: none;
  padding-top: none;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
#grid-container > a {
  font-size: 20px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  position: relative;
  height: 20vh;
  text-align: center;
  padding-top: 5vh;
  background: rgba(3, 13, 39, 0.7);
  transition: all 0.3s;
  outline: 2px solid teal;
  text-transform: uppercase;
}
#grid-container > a .v-icon {
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s;
  display: block;
  font-size: 8vh;
}
#grid-container > a .v-icon.fa-icons {
  font-size: 7vh;
  margin-bottom: 6px;
}
#grid-container > a:hover,
#grid-container > a:focus {
  background: rgba(3, 13, 39, 0.85);
  outline: 2px solid rgb(3, 13, 39);
  color: rgba(255, 255, 255, 0.9);
}
#grid-container > a:hover .v-icon,
#grid-container > a:focus .v-icon {
  transform: scale(1.2);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2vh;
}
#grid-container > a:hover .v-icon.fa-icons,
#grid-container > a:focus .v-icon.fa-icons {
  margin-bottom: 2.4vh;
}
#grid-container .sale {
  grid-column: 2/4;
}
#grid-container .accounting {
  grid-column: 4/6;
}
#grid-container .inventory {
  grid-column: 1/3;
}
#grid-container .reports {
  grid-column: 3/5;
}
#grid-container .staff {
  grid-column: 2/4;
}

.row-1,
.row-2,
.row-3 {
  animation-delay: 0.1s;
}
.row-2 {
  animation-delay: 0.3s;
}
.row-3 {
  animation-delay: 0.5s;
}

.disableLink {
  pointer-events: none;
  opacity: 0.4;
}

@media screen and (max-width: 1100px) {
  #grid-container {
    width: calc(100% - 20px);
  }
}
@media screen and (min-width: 501px) and (max-width: 767px) {
  .video-background {
    display: none;
  }
  #grid-container {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    margin-bottom: 50px !important;
  }
  #grid-container .dashboard {
    grid-column: 1/3 !important;
  }
  #grid-container .sale {
    grid-column: 3/6 !important;
  }
  #grid-container .accounting {
    grid-column: 6/9;
  }
  #grid-container .inventory {
    grid-column: 1/4 !important;
  }
  #grid-container .reports {
    grid-column: 4/7 !important;
  }
  #grid-container .suppliers {
    grid-column: 7/9 !important;
  }
  #grid-container .customers {
    grid-column: 1/3 !important;
  }
  #grid-container .staff {
    grid-column: 3/5 !important;
  }
  #grid-container .settings {
    grid-column: 5/7 !important;
  }
  #grid-container .about {
    grid-column: 7/9 !important;
  }
  #grid-container > a {
    background: rgba(3, 13, 39, 0.8);
  }
  #grid-container .sale {
    grid-column: 2;
  }
  #grid-container .reports {
    grid-column: 2;
  }
  #grid-container .inventory {
    grid-column: 1;
  }
}
@media screen and (max-width: 500px) {
  #grid-container {
    grid-template-columns: 1fr;
    padding-bottom: 50px;
  }
  #grid-container > a {
    grid-column: 1 !important;
  }
}
</style>
